import { render, staticRenderFns } from "./VehicleYear.vue?vue&type=template&id=2e67598a&"
import script from "./VehicleYear.vue?vue&type=script&lang=js&"
export * from "./VehicleYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports